<script setup lang="ts">
	import {injectEnv} from "@fd/Environment";
	import SymIcon from "@fd/helpers/SymIcon.vue";
	const props = defineProps({
	  show: Boolean
	});
	
	const env = injectEnv();
</script>

<template>
	<Transition name="modal">
	<div v-if="show" class="modal-mask">
		<div class="modal-container">
			<slot name="header">
				<div class="modal-header">
					<a href="#" @click.prevent="$emit('close')" :title="env.msg('window.close')">
						<sym-icon name="close"/>
					</a>
				</div>
			</slot>
			<slot name="body">
				<div class="modal-body">default body</div>
			</slot>
			<slot name="footer"></slot>
		</div>
	</div>
	</Transition>
</template>

<style>
.modal-mask {
  position: fixed;
  z-index: var(--modal-z-index);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}

.modal-container {
  margin: auto;
  border-radius: 2px;
  /*box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);*/
  transition: all 0.3s ease;
}

.modal-header {
  margin-top: 0;
  width: 100%; 
  text-align: right;
  margin-bottom: 2px;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
